import React from 'react';
import { ChatWidget } from '../../components/chat/ChatWidget';

const ChatPage: React.FC = () => {
  return (
    <div className="chat-page">
      <ChatWidget />
    </div>
  );
};

export default ChatPage;
